// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import InfiniteLoading from 'vue-infinite-loading'
import AOS from 'aos'
import 'aos/dist/aos.css'
import Print from 'vue-print-nb'

Vue.config.productionTip = false

Vue.prototype.$CONTINUAR_PLATAFORMA = 'Continuar na plataforma'
Vue.prototype.$PPP_URL_FILE = 'https://potenciasperifericas.org.br/public/storage/'

Vue.use(Print)

Vue.use(VueMask)

Vue.use(InfiniteLoading)

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyC90ovVx6Dn2qT39bpmjjdNbeP1PO3a6-E',
        libraries: 'places'
    }
})

/* eslint-disable no-new */
new Vue({
    created() {
        AOS.init()
    },
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js